import { SearchResultsSettings } from 'client/components/core/Sidebar/components/Settings/entities/search-results-settings'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { BlogCategoryDescriptionInterface } from 'common/types/entities/BlogCategoryDescriptionInterface'
import { BlogCategoryTitleInterface } from 'common/types/entities/BlogCategoryTitleInterface'
import { BlogPostListingInterface } from 'common/types/entities/BlogPostListingInterface'
import { ContactUsInterface } from 'common/types/entities/ContactUsInterface'
import EntityInterface from 'common/types/entities/EntityInterface'
import { LatestBlogPostsCarouselInterface } from 'common/types/entities/LatestBlogPostsCarouselInterface'
import { LatestBlogPostsInterface } from 'common/types/entities/LatestBlogPostsInterface'
import { RecaptchaInterface } from 'common/types/entities/RecaptchaInterface'
import { SearchResultsInterface } from 'common/types/entities/search-results-interface'
import React from 'react'
import ButtonSettingsNew from 'src/editor/shared/entities/button-new/button-settings'
import { SearchSettings } from 'src/editor/shared/entities/search/search-settings'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { ContactUsButtonEntityInterface } from 'src/shared/entities/contact-us-button/contact-us-button-entity.schema'
import { ContactUsFieldEntityInterface } from 'src/shared/entities/contact-us-field/contact-us-field-entity.schema'
import { AttachmentsInterface } from 'src/shared/types/entities/attachments-interface'
import { SearchInterface } from 'src/shared/types/entities/search-interface'
import BaseTextEntitySettings from '../../components/core/Sidebar/components/Settings/BaseTextEntitySettings'
import RecaptchaSettings from '../../components/core/Sidebar/components/Settings/entities/RecaptchaSettings'
import AttachmentsSettings from '../contact-us/settings/AttachmentsSettings'
import ButtonSettings from '../contact-us/settings/ButtonSettings'
import ContactUsFieldSettings from '../contact-us/settings/ContactUsFieldSettings'
import ContactUsSettings from '../contact-us/settings/ContactUsSettings'
import createCommonEntitySettings from '../createCommonEntitySettings'
import BlogLatestPostsSettings from './settings/BlogLatestPostsSettings'
import BlogPostListingSettings from './settings/BlogPostListingSettings'
import LatestBlogPostsCarouselSettings from './settings/LatestBlogPostsCarouselSettings'

function createSettingsForBlogPage(
  entity: EntityInterface,
  defaultEntity?: EntityInterface,
) {
  switch (entity.type) {
    case EntityTypeEnum.BlogPostListing:
      return (
        <BlogPostListingSettings
          entity={entity as BlogPostListingInterface}
          defaultEntity={defaultEntity as BlogPostListingInterface}
        />
      )
    case EntityTypeEnum.SearchResults:
      return (
        <SearchResultsSettings
          entity={entity as SearchResultsInterface}
          defaultEntity={defaultEntity as SearchResultsInterface}
        />
      )
    case EntityTypeEnum.Search:
      return (
        <SearchSettings
          entity={entity as SearchInterface}
          defaultEntity={defaultEntity as SearchInterface}
        />
      )
    case EntityTypeEnum.LatestBlogPosts:
      return (
        <BlogLatestPostsSettings
          entity={entity as LatestBlogPostsInterface}
          defaultEntity={defaultEntity as LatestBlogPostsInterface}
        />
      )
    case EntityTypeEnum.BlogCategoryTitle:
      return (
        <BaseTextEntitySettings
          entity={entity as BlogCategoryTitleInterface}
          defaultEntity={defaultEntity as BlogCategoryTitleInterface}
        />
      )
    case EntityTypeEnum.BlogCategoryDescription:
      return (
        <BaseTextEntitySettings
          entity={entity as BlogCategoryDescriptionInterface}
          defaultEntity={defaultEntity as BlogCategoryDescriptionInterface}
        />
      )
    case EntityTypeEnum.ContactUs:
      return (
        <ContactUsSettings
          entity={entity as ContactUsInterface}
          defaultEntity={defaultEntity as ContactUsInterface}
        />
      )
    case EntityTypeEnum.Button:
      return (
        <ButtonSettingsNew
          entity={entity as ActionButtonEntityInterface}
          defaultEntity={defaultEntity as ActionButtonEntityInterface}
        />
      )
    case EntityTypeEnum.ContactUsButton:
      return (
        <ButtonSettings
          entity={entity as ContactUsButtonEntityInterface}
          defaultEntity={defaultEntity as ContactUsButtonEntityInterface}
        />
      )
    case EntityTypeEnum.ContactUsField:
      return (
        <ContactUsFieldSettings
          entity={entity as ContactUsFieldEntityInterface}
          defaultEntity={defaultEntity as ContactUsFieldEntityInterface}
        />
      )
    case EntityTypeEnum.Recaptcha:
    case EntityTypeEnum.ContactUsRecaptcha:
      return (
        <RecaptchaSettings
          entity={entity as RecaptchaInterface}
          defaultEntity={defaultEntity as RecaptchaInterface}
        />
      )
    case EntityTypeEnum.Attachments:
      return (
        <AttachmentsSettings
          entity={entity as AttachmentsInterface}
          defaultEntity={defaultEntity as AttachmentsInterface}
        />
      )
    case EntityTypeEnum.LatestBlogPostsCarousel:
      return (
        <LatestBlogPostsCarouselSettings
          entity={entity as LatestBlogPostsCarouselInterface}
          defaultEntity={defaultEntity as LatestBlogPostsCarouselInterface}
        />
      )
    default:
      return createCommonEntitySettings(entity, defaultEntity)
  }
}

export default createSettingsForBlogPage
